// extracted by mini-css-extract-plugin
module.exports = {"accountModal":"styles_accountModal__ZVrIa","homeButton":"styles_homeButton__8UFpf","buttonsWrapper":"styles_buttonsWrapper__6l85R"};